import ErrorPage from "@/components/pages/ErrorPage";
import { SetupCompleteView } from "@/features/diaries/components/SetupCompleteView";
import { diaryByIdQueryOptions } from "@/features/diaries/api";
import {
    getPatientFirstSetupStepPath,
    type PatientSetupStepPath,
} from "@/features/diaries/utils/missingDetailsBuilders";
import { createFileRoute, redirect } from "@tanstack/react-router";

const SETUP_STEP_TO_ROUTE: Record<PatientSetupStepPath, `/diaries/$diaryId/${PatientSetupStepPath}`> = {
    "setup/hospital-number": "/diaries/$diaryId/setup/hospital-number",
    "setup/reference-date": "/diaries/$diaryId/setup/reference-date",
    "setup/side": "/diaries/$diaryId/setup/side",
};

function DiarySetupCompletePage() {
    const { diaryId } = Route.useParams();
    return <SetupCompleteView diaryId={diaryId} />;
}

export const Route = createFileRoute("/_app/diaries/$diaryId/setup/complete")({
    component: DiarySetupCompletePage,
    errorComponent: ({ error, reset }) => <ErrorPage error={error as Error} reset={reset} />,
    loader: async ({ context, params }) => {
        const diary = await context.queryClient.ensureQueryData(diaryByIdQueryOptions(params.diaryId));
        const setupStep = diary ? getPatientFirstSetupStepPath(diary) : null;

        if (setupStep) {
            throw redirect({
                to: SETUP_STEP_TO_ROUTE[setupStep],
                params: { diaryId: params.diaryId },
            });
        }

        return {};
    },
});
